export default __webpack_public_path__ + "c4d53b95f8f3cfcaec8d198561aa5fc7.svg";